import { Bot } from 'lucide-react'

interface TypingIndicatorProps {
  userName?: string
  avatarUrl?: string
  avatarColor?: string
  avatarInitials?: string
  isBot?: boolean
}

export function TypingIndicator({ 
  userName, 
  avatarUrl, 
  avatarColor = 'bg-gray-400',
  avatarInitials = '?',
  isBot = false,
}: TypingIndicatorProps) {
  return (
    <div className="flex items-start gap-2 px-2 sm:px-4 py-2 animate-fade-in">
      {/* Avatar */}
      {isBot ? (
        <div className="w-8 h-8 rounded-full bg-blue-600 dark:bg-blue-500 flex items-center justify-center text-white flex-shrink-0 shadow-xs ring-2 ring-blue-100 dark:ring-blue-900/40">
          <Bot className="h-4 w-4" />
        </div>
      ) : avatarUrl ? (
        <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 ring-1 ring-gray-200">
          <img src={avatarUrl} alt={userName} className="w-full h-full object-cover" />
        </div>
      ) : (
        <div className={`w-8 h-8 rounded-full ${avatarColor} flex items-center justify-center text-white font-semibold text-xs flex-shrink-0`}>
          {avatarInitials}
        </div>
      )}

      {/* Typing bubble */}
      <div className="bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700/80 rounded-2xl rounded-bl-sm px-3.5 py-2.5 shadow-xs flex items-center gap-2">
        {isBot && (
          <span className="text-xs font-medium text-gray-600 dark:text-gray-300">
            {userName || 'Bot respondiendo'}
          </span>
        )}
        <div className="flex items-center gap-1 pt-0.5">
          <div className="w-2 h-2 bg-blue-500 dark:bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 bg-blue-500 dark:bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-2 h-2 bg-blue-500 dark:bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  )
}
